import BaseApi from "./BaseApi";

export default class AuthApi extends BaseApi {
  static getUserInfo = () => this.get("userinfo");
}
